import { Fragment, ReactNode, useContext } from "react";

import {
  QuestionSavedAnswerVersionsContext,
  SavedAnswerField,
} from "./saved-answer-versions-context";

// A rich-text editor reads its value only when it mounts. This remounts the
// editor of one field when a saved answer replaces that field (TF-1786), so
// it shows the saved text. The question's other editors keep their focus.
const SavedAnswerEditorKey = ({
  field,
  children,
}: {
  field: SavedAnswerField;
  children: ReactNode;
}) => (
  <Fragment key={useContext(QuestionSavedAnswerVersionsContext)[field] ?? 0}>
    {children}
  </Fragment>
);

export default SavedAnswerEditorKey;
